import { getPublicAppOrigin } from './publicAppUrl';

export const SHARE_EXPIRY_OPTIONS = [
  { value: 1, label: '1 day' },
  { value: 3, label: '3 days' },
  { value: 7, label: '1 week' },
  { value: 14, label: '2 weeks' },
  { value: 30, label: '1 month' },
  { value: 90, label: '3 months' },
] as const;

export const DEFAULT_SHARE_EXPIRY_DAYS = 7;

export function getShareExpiryLabel(days: number): string {
  return SHARE_EXPIRY_OPTIONS.find(opt => opt.value === days)?.label ?? `${days} days`;
}

export function formatShareTimeRemaining(expiresAt: string): string {
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return 'Expired';

  const totalHours = Math.floor(ms / (1000 * 60 * 60));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (days >= 30) {
    const months = Math.floor(days / 30);
    const remDays = days % 30;
    return remDays > 0 ? `${months}mo ${remDays}d left` : `${months} month${months !== 1 ? 's' : ''} left`;
  }
  if (days >= 1) {
    return hours > 0 ? `${days}d ${hours}h left` : `${days} day${days !== 1 ? 's' : ''} left`;
  }
  if (totalHours >= 1) return `${totalHours} hour${totalHours !== 1 ? 's' : ''} left`;
  const mins = Math.max(1, Math.floor(ms / (1000 * 60)));
  return `${mins} min left`;
}

export function isShareExpired(expiresAt: string): boolean {
  return new Date(expiresAt).getTime() <= Date.now();
}

export function buildShareUrl(token: string): string {
  return `${getPublicAppOrigin()}/share/${token}`;
}

export function openWhatsAppShare(url: string, name?: string): void {
  const who = name?.trim() || 'my';
  const text = `Hi, here is ${who} Passport profile:\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
}
